<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon awesome-plus-circle.png" alt="" width="25" height="25" />
      <p class="title-bk">映像視聴ID登録</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: 'school' }">戻る</router-link>
    </div>
    <div class="container">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(confirmAdded)" ref="form">
          <table class="table table-form">
            <tbody>
              <ChoiceField
                v-model="corporationChoiceFieldMultiModels"
                extraRules="required_select"
                label="法人名（法人ID）"
                placeholder="選択して下さい"
                resourceType="corporation"
                modelFieldName="corporation"
                :choiceDisable="loggedInAsCorporation || loggedInAsBrand"
                :childFieldNames="['brand', 'school', 'course', 'tamaiClass']"
                :formData="currentVideoViewing"
              />
              <ChoiceField
                v-model="brandChoiceFieldMultiModels"
                extraRules="required_select"
                label="ブランド名（ブランドID）"
                placeholder="選択して下さい"
                resourceType="brand"
                modelFieldName="brand"
                :choiceDisable="loggedInAsBrand || isEmpty(currentVideoViewing.corporation)"
                :childFieldNames="['school', 'course', 'tamaiClass']"
                :formData="currentVideoViewing"
              />
              <ChoiceField
                v-model="schoolChoiceFieldMultiModels"
                extraRules="required_select"
                label="教場名（教場ID）"
                placeholder="選択して下さい"
                resourceType="school"
                modelFieldName="school"
                :choiceDisable="isEmpty(currentVideoViewing.brand)"
                :childFieldNames="['tamaiClass']"
                :formData="currentVideoViewing"
              />
              <ChoiceField
                v-model="courseChoiceFieldMultiModels"
                extraRules="required_select"
                label="コース名（コースID）"
                placeholder="選択して下さい"
                resourceType="course"
                modelFieldName="course"
                :choiceDisable="isEmpty(currentVideoViewing.brand)"
                :childFieldNames="['tamaiClass']"
                :formData="currentVideoViewing"
              />
              <ChoiceField
                v-model="classChoiceFieldMultiModels"
                extraRules="required_select"
                label="クラス名（クラスID）"
                placeholder="選択して下さい"
                resourceType="class"
                modelFieldName="tamaiClass"
                :choiceDisable="
                  isEmpty(currentVideoViewing.brand) ||
                  isEmpty(currentVideoViewing.school) ||
                  isEmpty(currentVideoViewing.course)
                "
                :formData="currentVideoViewing"
              />

              <SelectField
                v-model="currentVideoViewing.figuredProduct"
                extraRules="required_select"
                label="利用教材"
                placeholder="選択してください"
                inputClass="col-lg-10"
                :options="schoolFiguredProducts"
                optionValue="code"
                optionLabel="name"
                @input="addVideoPoles"
              />

              <TextField
                v-model="currentVideoViewing.nameReading"
                extraRules="required"
                label="映像視聴ID名"
                placeholder="映像視聴IDの表示する名前を自由に入力してください（例：○○教室用）"
              />

              <IdInputField
                v-model="currentVideoViewing.uid"
                @input="generatePoleId(currentVideoViewing.uid)"
                extraRules="required_select"
                label="IDに使用する文字"
                class="videoViewingBaseId"
                placeholder="映像視聴IDの生成に使用する文字を半角英数字で自由に入力してください"
                resourceType="video_viewing"
                :showGreenCircle="false"
              />
              <tr v-for="(videoViewingPole, index) in currentVideoViewing.videoPoles" :key="videoViewingPole.id">
                <template v-if="currentVideoViewing.figuredProduct == '10'">
                  <th scope="row" class="form-inline brandname">
                    映像視聴ID
                    <div class="body-td-explain" v-if="index == 0">（図形の極 + 数の極）</div>
                    <div class="body-td-explain" v-else>（中学生の図形の極 + 中学生の代数の極）</div>
                  </th>
                </template>
                <template v-else-if="currentVideoViewing.figuredProduct == '40'">
                  <th scope="row" class="form-inline brandname">
                    映像視聴ID
                    <div class="body-td-explain">（魔法の国語 Grade{{ index + 1 }}）</div>
                  </th>
                </template>
                <template v-else-if="currentVideoViewing.figuredProduct != ''">
                  <th scope="row" class="form-inline brandname">
                    映像視聴ID
                  </th>
                </template>
                <td />
                <td class="form-inline brandname">
                  <template v-if="videoViewingPole.uid">
                    {{ videoViewingPole.uid }}
                    <template v-if="videoViewingPoleIdValid()">
                      <img src="@/assets/images/Ellipse 644.png" class="img-inline" alt width="25.3" height="25.3" />
                      <div class="body-td-explain">このIDを使用可能です</div>
                    </template>
                  </template>
                  <template v-else> [ IDに使用する文字 ]に入力すると自動で生成されます </template>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="text-center">
            <button type="submit" class="btn-confirm">確認</button>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { ValidationObserver } from 'vee-validate';
import EventBus from '@/helpers/EventBus.js';
import TextField from '@/components/forms/TextField.vue';
import ChoiceField from '@/components/forms/ChoiceField.vue';
import IdInputField from '@/components/forms/IdInputField.vue';
import SelectField from '@/components/forms/SelectField.vue';
import JQuery from 'jquery';
import {
  basicCorporationNameIdPresent,
  basicBrandNameIdPresent,
  basicSchoolNameIdPresent,
  basicCourseNameIdPresent,
  basicTamaiClassNameIdPresent,
} from '@/presenters/fields';

export default {
  data() {
    return {
      currentVideoViewing: {},
    };
  },
  components: {
    ValidationObserver,
    TextField,
    ChoiceField,
    IdInputField,
    SelectField,
  },

  computed: {
    corporationChoiceFieldMultiModels() {
      return basicCorporationNameIdPresent(this.currentVideoViewing.corporation);
    },
    brandChoiceFieldMultiModels() {
      return basicBrandNameIdPresent(this.currentVideoViewing.brand);
    },
    schoolChoiceFieldMultiModels() {
      return basicSchoolNameIdPresent(this.currentVideoViewing.school);
    },
    courseChoiceFieldMultiModels() {
      return basicCourseNameIdPresent(this.currentVideoViewing.course);
    },
    classChoiceFieldMultiModels() {
      return basicTamaiClassNameIdPresent(this.currentVideoViewing.tamaiClass);
    },
    schoolFiguredProducts() {
      if (this.currentVideoViewing.school) {
        return this.currentVideoViewing.school.figuredProducts;
      } else {
        return [];
      }
    },
    ...mapState(['video_viewing']),
    ...mapState('form', ['prevFormData']),
    ...mapState(['corporation']),
    ...mapState(['brand']),
    ...mapGetters('auth', ['loggedInAsCorporation', 'loggedInAsBrand']),
  },
  mounted() {
    EventBus.$on('SET_USER_PROFILE', this.setCurrentRoleHandler);
  },
  created() {
    this.currentVideoViewing = this.createFreshVideoViewingObject();
  },
  beforeDestroy() {
    EventBus.$off('SET_USER_PROFILE', this.setCurrentRoleHandler);
  },
  methods: {
    createFreshVideoViewingObject() {
      if (this.video_viewing.editingVideoViewing) {
        // Reset content of pulldown when reselecting school.
        this.video_viewing.editingVideoViewing.figuredProduct = '';
        this.video_viewing.editingVideoViewing.videoPoles = [];
        this.$logger.debug('Editing old Video Viewing with ID ' + this.video_viewing.editingVideoViewing);
        return this.video_viewing.editingVideoViewing;
      } else if (this.prevFormData) {
        // Reset content of pulldown when reselecting school.
        this.prevFormData.figuredProduct = '';
        this.prevFormData.videoPoles = [];
        this.$logger.debug('Restoring previous form data', this.prevFormData);
        return this.prevFormData;
      } else {
        let newVideoViewing = {
          corporation: null,
          brand: null,
          school: null,
          course: null,
          tamaiClass: null,
          figuredProduct: '',
          uid: null,
          nameReading: null,
          videoPoles: [],
        };
        if (this.loggedInAsCorporation) {
          newVideoViewing['corporation'] = this.corporation.corporation;
        }
        if (this.loggedInAsBrand) {
          newVideoViewing['brand'] = this.brand.brand;
          newVideoViewing['corporation'] = this.brand.brand.corporation;
        }
        return newVideoViewing;
      }
    },
    addVideoPoles(productCode) {
      this.currentVideoViewing.videoPoles = [];
      switch (productCode) {
        case '10':
          for (let index = 0; index < 2; index++) {
            this.currentVideoViewing.videoPoles.push({ uid: null, password: '' });
          }
          break;
        case '40':
          for (let index = 0; index < 4; index++) {
            this.currentVideoViewing.videoPoles.push({ uid: null, password: '' });
          }
          break;
        default:
          this.currentVideoViewing.videoPoles.push({ uid: null, password: '' });
          break;
      }
      this.generatePoleId(this.currentVideoViewing.uid);
    },
    generatePoleId(baseId) {
      for (let index = 0; index < this.currentVideoViewing.videoPoles.length; index++) {
        if (baseId) {
          if (this.currentVideoViewing.figuredProduct == '10' || this.currentVideoViewing.figuredProduct == '40') {
            this.currentVideoViewing.videoPoles[index].uid = baseId + '_' + (index + 1);
          } else {
            this.currentVideoViewing.videoPoles[index].uid = baseId;
          }
        } else {
          this.currentVideoViewing.videoPoles[index].uid = null;
        }
      }
    },
    videoViewingPoleIdValid() {
      return JQuery('.videoViewingBaseId input').hasClass('passed');
    },
    confirmAdded() {
      this.$logger.debug('Started Adding: ' + JSON.stringify(this.currentVideoViewing));
      this.startEditingVideoViewing(this.currentVideoViewing);
      this.$router.push({ name: 'video-viewing-confirm' });
    },
    setCurrentRoleHandler(payload) {
      if (this.loggedInAsCorporation) {
        this.currentVideoViewing.corporation = payload.data;
      }

      if (this.loggedInAsBrand) {
        this.currentVideoViewing.brand = payload.data;
        this.currentVideoViewing.corporation = payload.data.corporation;
      }
    },
    ...mapActions('video_viewing', ['startEditingVideoViewing']),
  },
};
</script>
<style scoped>
.btn-confirm {
  margin-left: 0px;
}
.img-inline {
  margin-left: 5px;
}
.line-break {
  width: 100%;
}
.body-td-explain {
  margin-left: 5px;
  font-size: 10px;
}
</style>
